import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { Columns, Column } from '@components/Columns';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { CTALink } from '@components/CTALink';

export interface WrapperProps {
  width: number;
  height: number;
}

export type Alignment = 'left' | 'center' | 'right';

export interface Gap {
  sm: number;
  belowSm: number;
}

export interface Scale {
  xl: number;
  lg: number;
  sm: number;
  belowSm: number;
}

export const StyledCTALink = styled(CTALink)`
  -webkit-transition: filter 0.3s ease-in;
  -moz-transition: filter 0.3s ease-in;
  -o-transition: filter 0.3s ease-in;
  transition: filter 0.3s ease-in;

  :hover {
    filter: contrast(12%);
  }
  :active {
    filter: contrast(50%);
  }
`;

export const StyledColumns = styled(Columns)<{ alignment: Alignment; gap: Gap; scale: Scale }>`
  max-width: 100%;
  padding: 0px ${themeSpace(3)};
  gap: ${({ gap }) => gap.belowSm}px;
  justify-content: ${({ alignment }) => alignment};
  ${themeMediaQuery('below_sm')} {
    transform: scale(${({ scale }) => scale.belowSm});
  }
  ${themeMediaQuery('sm')} {
    gap: ${({ gap }) => gap.sm}px;
    transform: scale(${({ scale }) => scale.sm});
  }
  ${themeMediaQuery('md')} {
    transform: scale(${({ scale }) => scale.lg});
  }
  ${themeMediaQuery('xl')} {
    transform: scale(${({ scale }) => scale.xl});
  }
`;

export const StyledColumn = styled(Column)<{ imageScale: Scale }>`
  width: auto;
  padding: 0px;
  ${themeMediaQuery('below_sm')} {
    transform: scale(${({ imageScale }) => imageScale.belowSm});
  }
  ${themeMediaQuery('sm')} {
    transform: scale(${({ imageScale }) => imageScale.sm});
  }
  ${themeMediaQuery('md')} {
    transform: scale(${({ imageScale }) => imageScale.lg});
  }
  ${themeMediaQuery('xl')} {
    transform: scale(${({ imageScale }) => imageScale.xl});
  }
`;

export const StyledFlex = styled(Flex)<{ sm: WrapperProps; belowsm: WrapperProps; circle?: string }>`
  text-align: center;
  overflow: hidden;
  border-radius: ${({ circle }) => (circle ? 50 : 0)}%;
  width: ${({ belowsm }) => belowsm.width}px;
  height: ${({ belowsm }) => belowsm.height}px;
  ${themeMediaQuery('sm')} {
    width: ${({ sm }) => sm.width}px;
    height: ${({ sm }) => sm.height}px;
  }
`;

export const StyledText = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    font-size: 20px;
    line-height: 24px;
  }
`;
